






























import '../styles/screen-tile.css'
import Vue from 'vue'

export default Vue.extend({
  data() {
    return {
      tabModel: null as any,
    }
  },
  beforeMount: function () {
    this.tabModel = this.tab
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    subTitle: {
      type: String,
      required: false,
    },
    children: {
      type: [String, Object],
      default: 'div',
    },
    actionText: {
      type: String,
      required: false,
    },
    tab: {
      type: String,
      required: false,
    },
    tabs: {
      type: Array,
      required: false,
    },
  },
  name: 'ScreenTile',
  methods: {},
})
